import { Howl } from 'howler';
import { BasePreferences, IPreferencesService } from '../../preferences/model/types';
export default class SoundProvider<T extends BasePreferences> {
  codes = {
    FANFARE: 1,
    BELL: 2,
    INFO: 3,
    COIN: 4,
    MOVE: 5,
    DICE: 6,
    BEEP: 7,
    ACT: 8,
    SHUFF1: 9,
    SHUFF2: 10,
    SHUFF3: 11,
    SHUFF4: 12,
    CARD: 13,
  };

  categories = {
    GLOBAL: 1,
    OPP_MOVE: 2,
    YOUR_MOVE: 3,
    JOIN_TABLE: 4,
    INVITATION: 5,
  };

  enabled = false;
  mute = false;

  audioObjects: Howl[] = [];
  categoriesEnabled: { [key: number]: boolean } = {};

  audioQueues: { [channel: string]: { code: number; cat: number }[] } = {};

  playing = false; // Play ONE track flag

  constructor(private preferencesServiece: IPreferencesService<T>) {
    this.onEndPlay = this.onEndPlay.bind(this);
    if (window.Audio) this.enabled = true;
    this.preferencesServiece.onPreferencesChanged.subscribe(this.onSoundPreferencesChanged);
    this.categoriesEnabled[this.categories.GLOBAL] = true;
    this.categoriesEnabled[this.categories.OPP_MOVE] = true;
    this.categoriesEnabled[this.categories.YOUR_MOVE] = true;
    this.categoriesEnabled[this.categories.JOIN_TABLE] = true;
    this.categoriesEnabled[this.categories.INVITATION] = true;

    this.addAudio(this.codes.BEEP, 'assets/sound/alien1');
    this.addAudio(this.codes.BELL, 'assets/sound/bell2');
    this.addAudio(this.codes.COIN, 'assets/sound/clink');
    this.addAudio(this.codes.DICE, 'assets/sound/dice');
    this.addAudio(this.codes.MOVE, 'assets/sound/ding1');
    this.addAudio(this.codes.INFO, 'assets/sound/drip1');
    this.addAudio(this.codes.FANFARE, 'assets/sound/fanfare');
    this.addAudio(this.codes.ACT, 'assets/sound/knock1');
    this.addAudio(this.codes.SHUFF1, 'assets/sound/shuffling1');
    this.addAudio(this.codes.SHUFF2, 'assets/sound/shuffling2');
    this.addAudio(this.codes.SHUFF3, 'assets/sound/shuffling3');
    this.addAudio(this.codes.SHUFF4, 'assets/sound/shuffling4');
    this.addAudio(this.codes.CARD, 'assets/sound/card');
  }

  onSoundPreferencesChanged = (preferences: BasePreferences) => {
    if (preferences.SOUND_ALL_MUTE) {
      return this.setMute(true);
    }
    this.setMute(false);
    this.categoriesEnabled[this.categories.OPP_MOVE] = preferences.SOUND_ON_OPPONENT_MOVE;
    this.categoriesEnabled[this.categories.YOUR_MOVE] = preferences.SOUND_ON_YOUR_MOVE;
    this.categoriesEnabled[this.categories.JOIN_TABLE] = preferences.SOUND_ON_JOINING_YOUR_TABLE;
    this.categoriesEnabled[this.categories.INVITATION] = preferences.SOUND_ON_INVITATION;
  };

  checkType(type: string) {
    const audio = new Audio();
    return audio.canPlayType(type) !== '';
  }

  onEndPlay = (code: number) => {
    this.playing = false;

    for (const channel in this.audioQueues) {
      if (this.audioQueues.hasOwnProperty(channel) && this.audioQueues[channel].length > 0) {
        var sound = this.audioQueues[channel][0];
        if (sound.code === code) {
          this.audioQueues[channel].shift();
          if (this.audioQueues[channel].length > 0) {
            this.playNextInQueue(channel);
          }
          break;
        }
      }
    }
  };

  /**
   *
   * @param code
   * @param src Путь к звуковому файлу без расширения
   */
  addAudio = (code: number, src: string) => {
    if (!this.enabled) return;
    if (this.audioObjects[code]) return;
    this.audioObjects[code] = new Howl({
      src: [src + '.ogg', src + '.aac', src + '.mp3'],
      onend: this.onEndPlay.bind(this, code),
    });
  };

  setCategoryEnable = (cat: number, enabled: boolean) => {
    if (this.categoriesEnabled[cat] === undefined) return;
    this.categoriesEnabled[cat] = enabled;
  };

  setMute = (mute: boolean) => {
    this.mute = mute;
  };

  isSoundRegistered = (code: number) => {
    return !!this.audioObjects[code];
  };

  queue = (code: number, cat: number, channel: string) => {
    if (!this.audioQueues[channel]) {
      this.audioQueues[channel] = [];
    }

    this.audioQueues[channel].push({
      code: code,
      cat: cat,
    });

    if (this.audioQueues[channel].length === 1) {
      this.playNextInQueue(channel);
    }
  };

  playNextInQueue = (channel: string) => {
    const sound = this.audioQueues[channel][0];
    this.play(sound.code, sound.cat);
  };

  /**
   * Plays sound 'code' in sound category 'cat'
   * @param {number} code one of Sounds.codes.XXXXX
   * @param {number} cat one of Sounds.categories.XXXXX
   */
  play = (code: number, cat: number) => {
    const audio = this.audioObjects[code];
    if (!audio) return;

    if (code !== this.codes.BEEP) {
      if (this.mute) return;
      if (!this.categoriesEnabled[cat]) return;
    }
    audio.play();
  };

  /**
   * Plays one of the sounds from array 'codes' in sound category 'cat'
   * @param {number} cat one of Sounds.categories.XXXXX
   * @param {Array} codes array of numbers from Sounds.codes.XXXXX
   */
  playRandom = (cat: number, codes: Array<number>) => {
    const code = codes[Math.floor(Math.random() * codes.length)];
    this.play(code, cat);
  };
}
